
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/legal/notice-at-collection",
      function () {
        return require("private-next-pages/[lang]/legal/notice-at-collection/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/legal/notice-at-collection"])
      });
    }
  